import { AxiosError } from 'axios'

export const getErrorMessage = (error: unknown) => {
  if (typeof error === 'string') {
    return error
  }

  if (error instanceof AxiosError) {
    const errorMessage = error.response?.data?.message

    if (errorMessage) {
      if (Array.isArray(errorMessage)) {
        return errorMessage.join(', ')
      }

      return errorMessage
    }
  }

  if (error instanceof Error && error.message) {
    return error.message
  }

  return 'Something went wrong!'
}
